__turbopack_context__.v({
  "active": "editor-switcher-module__-mZXBG__active",
  "buttonLabel": "editor-switcher-module__-mZXBG__buttonLabel",
  "dark": "editor-switcher-module__-mZXBG__dark",
  "switcherButton": "editor-switcher-module__-mZXBG__switcherButton",
  "switcherContainer": "editor-switcher-module__-mZXBG__switcherContainer",
});
